<template>
  <div class="reports">
    <h1>Upload de Documentos<span class="h1-underline"></span></h1>
    <h4>Faça o upload dos seguintes documentos:</h4>
    <div class="form-container">
      <v-container>
        <v-row>
          <v-col
          :cols="6"
          style="padding:10px 50px"
          >
            <h2>Documentos Titular<span class="h2-underline"></span></h2>

            <v-list-item
              v-for="item in inputsTitular"
              :key="item.title"
              id="docsTitular"
            >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-file-input
                  :rules="rules"
                  accept="image/png, image/jpeg, image/bmp"
                  :placeholder="item.placeholder"
                  prepend-icon="mdi-paperclip"
                  label=""
                ></v-file-input>
                 <v-icon v-show="item.tooltip" v-on="on">info</v-icon>
               </template>
              <span>{{item.info}}</span>
            </v-tooltip>
            </v-list-item>
            <div class="d-flex add-btn">
              <v-btn v-on:click="addInputs" x-small color="black" fab><v-icon dark>add</v-icon></v-btn>
              <p>Tenho outra conta bancária</p>
            </div>
          </v-col>
          <v-col
          :cols="6"
          style="padding:10px 50px"
          >
            <h2>Documentos Cônjuge<span class="h2-underline"></span></h2>
             <v-list-item
              v-for="item in inputsConjuge"
              :key="item.title"
            >
              <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-file-input
                  :rules="rules"
                  accept="image/png, image/jpeg, image/bmp"
                  :placeholder="item.placeholder"
                  prepend-icon="mdi-paperclip"
                  label=""
                ></v-file-input>
                 <v-icon v-show="item.tooltip" v-on="on">info</v-icon>
               </template>
              <span>{{item.info}}</span>
            </v-tooltip>
            </v-list-item>
          </v-col>
        </v-row>
      </v-container>
    </div>
     <v-btn
      :loading="loading5"
      :disabled="loading5"
      color="blue-grey"
      class="ma-2 white--text submit-btn"
      @click="loader = 'loading5'"
      rounded
    >Submeter
     <v-icon dark>navigate_next</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name:'uploads',
  data: () => ({
      rules: [
        value => !value || value.size < 200000000 || '',
      ],
      inputsTitular: [
          {title:'Cartão de Cidadão', placeholder: 'Cartão de Cidadão', tooltip:true, info:'info1'},
          {title:'IRS', placeholder: 'IRS', tooltip:true, info:'info2'},
          {title:'Recibos de Vencimento Últimos 3 Meses (mês 1)', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 1)', tooltip:false, info:'info3'},
          {title:'Recibos de Vencimento Últimos 3 Meses (mês 2)', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 2)', tooltip:true, info:'info4'},
          {title:'Recibos de Vencimento Últimos 3 Meses (mês 3)', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 3)', tooltip:false, info:'info5'},
          {title:'teste', placeholder: 'Comprovativo de NIB', tooltip:true, info:'info6'},
          {title:'teste', placeholder: 'Comprovativo Morada', tooltip:true, info:'info7'},
          {title:'teste', placeholder: 'Mapa CRC', tooltip:true, info:'info'},
          {title:'teste', placeholder: 'Carta Conforto', tooltip:true, info:'info'},
          {title:'Extrato Bancário Últimos 3 Meses (mês 1)', placeholder: 'Extrato Bancário Últimos 3 Meses (mês 1)', tooltip:false, info:'info'},
          {title:'Extrato Bancário Últimos 3 Meses (mês 2)', placeholder: 'Extrato Bancário Últimos 3 Meses (mês 2)', tooltip:true, info:'info'},
          {title:'Extrato Bancário Últimos 3 Meses (mês 3)', placeholder: 'Extrato Bancário Últimos 3 Meses (mês 3)', tooltip:true, info:'info'},
        ],
         inputsConjuge: [
          {title:'teste', placeholder: 'Cartão de Cidadão',tooltip:true, info:'info1'},
          {title:'teste', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 1)', tooltip:true, info:'info1'},
          {title:'teste', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 2)', tooltip:true, info:'info1'},
          {title:'teste', placeholder: 'Recibos de Vencimento Últimos 3 Meses (mês 3)', tooltip:true, info:'info1'},
          {title:'teste', placeholder: 'Mapa CRC', tooltip:true, info:'info1'},
        ],
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
    }),

    methods: {
      addInputs() {
        this.inputsTitular.push({
          placeholder:'Extrato Bancário Últimos 3 Meses (mês 1)',
        })
        this.inputsTitular.push({
          placeholder:'Extrato Bancário Últimos 3 Meses (mês 2)',
        })
        this.inputsTitular.push({
          placeholder:'Extrato Bancário Últimos 3 Meses (mês 3)',
        })
      }
    }
  }
</script>

<style scoped>
  h1,h4{
      margin-left: 296px;
      color: black;
      font-size: 20px;
      text-transform: uppercase;
      margin-top: 50px;
      position: relative;
      display: block;
    }
    .h1-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60px;
      height: 3px;
      background-color: black;
      margin-bottom: -6px;
    }

    h4{
      font-size: 14px;
      text-transform: none;
      margin-top: 50px;
      font-weight: 400;
    }

     h2{
      color: black;
      font-size: 14px;
      text-transform: uppercase;
      position: relative;
      display: block;
      margin-bottom: 20px;
    }
    .h2-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 80%;
      height: 1px;
      background-color: black;
      margin-bottom: -6px;
    }

    .v-input{
      font-size:13px!important;
    }

    .v-list-item{
      padding:0;
      width: 80%!important;
    }

    .submit-btn{
      margin-left: 296px!important;
      background-color:rgb(246, 147, 30)!important;
      letter-spacing: normal;
      margin-bottom: 50px!important;
    }

    .add-btn{
      margin-top: 20px;
    }

    .add-btn .v-btn{
      width: 25px;
      min-width: 0;
      min-height: 0;
      height: 25px;
    }

    .add-btn p{
      font-size: 12px;
      color: black;
      line-height: 28px;
      margin-left: 10px;
    }

    .add-btn .v-btn i{
      color: white!important;
    }

</style>